<template>
  <div class="layout-col">
    <div
      ref="text"
      class="text"
      :class="{
        text12: size == 12,
      }"
      @click="$emit('tap')"
    >
      <span
        :style="`-webkit-line-clamp: ${row};`"
        :class="{ hidden: !show }"
        v-html="text"
      ></span>
    </div>

    <div v-if="showBut" class="ti-but layout-row" @click="show = !show">
      <div v-if="!show" class="ti_show_but layout-row">
        <div>查看全部</div>
        <img src="../../image/gray_down_icon.png" alt="" />
      </div>
      <div v-else class="ti_show_but layout-row">
        <div>收起</div>
        <img
          style="transform: rotateX(180deg)"
          src="../../image/gray_down_icon.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["text", "row", "size"],
  data() {
    return {
      show: false,
      showBut: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.$refs.text.clientHeight;
      this.showBut = this.$refs.text.clientHeight > 20 * this.row;
    });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.hidden {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
.text {
  width: 100%;
  flex-shrink: 0;
  margin-top: 0.55rem;
  font-size: 0.7rem;
  font-weight: 500;
  color: #000;
  line-height: 23px;
  white-space: pre-line;
  word-break: break-all;
  word-wrap: break-word;
}
.text12 {
  margin-top: 0.55rem;
  font-size: 0.6rem;
  font-weight: 500;
  color: #000;
  line-height: 18px;
  white-space: pre-line;
  word-break: break-all;
  word-wrap: break-word;
}
.ti_show_but {
  margin-top: 0.5rem;
  margin-left: auto;
  align-items: center;
  justify-content: center;
  //   width: 3.75rem;
  padding: 0 0.4rem;
  height: 0.95rem;
  border: 1px solid #eaeaea;
  border-radius: 0.5rem;
  font-size: 0.6rem;
  color: #999;
  img {
    margin-left: 0.25rem;
    width: 0.4rem;
    height: 0.2rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/comment/content.vue